import { Button } from '../Input2';
import { Alerts, General } from '../StrokeIcons';
import Popup, { type PopupProps } from './Popup';

type DeleteVoicePopupProps = PopupProps & {
  onDelete: () => void;
};

export default function DeleteVoicePopup({ onClose, onDelete }: DeleteVoicePopupProps) {
  return (
    <Popup onClose={onClose}>
      {/* Header with icon */}
      <div className="flex flex-col items-center px-6 pt-6">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/20">
          <Alerts.AlertTriangle className="h-6 w-6 text-red-600 dark:text-red-400" />
        </div>

        <h3 className="mt-4 text-lg font-semibold text-gray-900 dark:text-gray-100">Delete voice</h3>
        <p className="text-center text-sm text-gray-600 dark:text-gray-400 mt-1">
          This will delete all the generated audio files for all smart campaigns
        </p>
      </div>

      {/* Content */}
      <div className="px-6 py-4">
        <p className="text-center text-sm text-gray-600 dark:text-gray-400">
          Are you sure you want to delete this item? This action cannot be undone.
        </p>
      </div>

      {/* Footer with actions */}
      <div className="flex gap-3 border-t border-gray-200 dark:border-gray-800 px-6 py-4">
        <Button className="flex-1" onClick={onClose}>
          Cancel
        </Button>
        <Button className="flex-1" color="red" onClick={onDelete} icon={<General.Trash01 />}>
          Delete
        </Button>
      </div>
    </Popup>
  );
}

